import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import { getAgentLiveChatLink, getIsLiveChatDisabled, getIsUnderAgent } from 'shared/utils/agentSocialLinks'
import { bootLiveChat, shutdownLiveChat } from 'shared/utils/liveChat'

import {
  selectAgentSocialLinks,
  selectGetAgentSocialLinksComm,
  selectIsUserAuthenticated,
  selectUserData,
} from 'features/auth/selectors'

export const useLiveChat = () => {
  const isAuth = useSelector(selectIsUserAuthenticated, shallowEqual)
  const user = useSelector(selectUserData, shallowEqual)
  const agentSocialLinks = useSelector(selectAgentSocialLinks, shallowEqual)
  const socialLinksComm = useSelector(selectGetAgentSocialLinksComm, shallowEqual)

  const isUnderAgent = getIsUnderAgent(user)
  const agentLiveChatLink = isUnderAgent ? getAgentLiveChatLink(agentSocialLinks) : undefined
  const isLiveChatDisabled = getIsLiveChatDisabled(isAuth, agentSocialLinks, user)

  useEffect(() => {
    if (isLiveChatDisabled) {
      shutdownLiveChat()
      return
    }

    const waitingForAgentLinks = isUnderAgent && !socialLinksComm.isSuccess && !socialLinksComm.error

    if (!waitingForAgentLinks) {
      bootLiveChat(agentLiveChatLink)
    }
  }, [agentLiveChatLink, isLiveChatDisabled, isUnderAgent, socialLinksComm.error, socialLinksComm.isSuccess])
}
